import { render, staticRenderFns } from "./DetailCoupon.vue?vue&type=template&id=43b1b74a&scoped=true&"
import script from "./DetailCoupon.vue?vue&type=script&lang=js&"
export * from "./DetailCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b1b74a",
  null
  
)

export default component.exports